import { useEffect } from "react";

/** Set only on test builds (e.g. "PHASE 4 TEST"); empty on the live app. */
export const ENV_LABEL: string = (import.meta.env.VITE_ENV_LABEL as string | undefined)?.trim() ?? "";

/**
 * Makes a test build impossible to confuse with the live app: a bar across
 * the top of every page, a faint repeating watermark over the whole screen,
 * and the label in the browser tab title. Renders nothing on the live app.
 */
export function EnvBadge() {
  useEffect(() => {
    if (!ENV_LABEL) return;
    const prefix = `[${ENV_LABEL}] `;
    const apply = () => {
      if (!document.title.startsWith(prefix)) document.title = prefix + document.title.replace(/^\[[^\]]*\]\s*/, "");
    };
    apply();
    const el = document.querySelector("title");
    if (!el) return;
    const obs = new MutationObserver(apply);
    obs.observe(el, { childList: true, characterData: true, subtree: true });
    return () => obs.disconnect();
  }, []);

  if (!ENV_LABEL) return null;

  const tile = encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="260" height="180"><text x="130" y="95" text-anchor="middle" font-family="sans-serif" font-size="26" font-weight="700" fill="#dc2626" fill-opacity="0.13" transform="rotate(-24 130 90)">${ENV_LABEL}</text></svg>`
  );

  return (
    <>
      <div
        aria-hidden="true"
        className="pointer-events-none fixed inset-0 z-[9998]"
        style={{ backgroundImage: `url("data:image/svg+xml,${tile}")` }}
      />
      <div
        role="status"
        className="pointer-events-none fixed inset-x-0 top-0 z-[9999] bg-red-600 py-0.5 text-center text-[11px] font-bold uppercase tracking-widest text-white"
      >
        {ENV_LABEL} · not the live app
      </div>
    </>
  );
}
